import store from '../store/store.js';
import autoBind from 'react-autobind';

  function status(response) {  
    if (response.status >= 200 && response.status < 300) {
  //    console.log('Fetch success - status: ' + response.status);  
      return Promise.resolve(response)  
    } else {
      console.log('Fetch rejected - status:' + response.statusText )  
      return Promise.reject(new Error(response.statusText))  
    }  
  };


  function json(response) {  
    return response.json()  
  };

  function queryparams(data) {
    const esc = encodeURIComponent;
    var query = Object.keys(data)
        .map(k => esc(k) + '=' + esc(data[k]))
        .join('&');
    return query;
  }

class Api {
    constructor() {
      autoBind(this);
    }

    request (httpMethod, apiMethod, requestBody = '', type = 'json') {
      let  headers = {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }

      if (httpMethod === 'POST') {
        return fetch(store.host + '/' + apiMethod, {
          method: 'POST',
          //headers: headers,
          body: requestBody,
          mode: 'cors',
          //credentials: 'include'
        })
      }
      else 
        if (httpMethod === 'GET'){
        return fetch(store.host + '/' + apiMethod, {
          method: 'GET',
          //headers: headers,
          mode: 'cors',
          //credentials: 'include'
        })
      }
      else return Promise.reject(new Error('request: Wrong httpMethod. Must be GET or POST.'))
    }

    login (data, callback) {
      const userName = data.user;
      const userPassword = data.password;
      this.request('GET', 'login?' + queryparams(data))
        .then(status)  
        .then(json)  
        .then(function(data) {  
          console.log('Login succeeded with JSON response', data);

          callback(data);
          
        })
        .catch(function(error) {  
          console.log('Login failed', error);
          callback(false);  
        });
    }


    check (session, callback){
      const data = { session: session };
      this.request('GET', 'check?' + queryparams(data))
        .then(status)  
        .then(json)  
        .then(function(data) {  
          callback(data, session);
          })
        .catch(function(error) {  
          console.log('Check failed', error);
          callback(false);
        })
    }

    getorders (callback){
      const data = { session: store.auth.session };
      this.request('GET', 'getorders?' + queryparams(data))
        .then(status)  
        .then(json)  
        .then(function(data) {  
          console.log('getorders succeeded with JSON response', data);
          callback(data);
          })
        .catch(function(error) {  
          console.log('getOrders failed', error);
          callback(false);
        })
    }

    newOrder (postdata, callback){
      const data = { session: store.auth.session};

      this.request('POST', 'neworder?' + queryparams(data), postdata)
        .then(status)  
        .then(json)  
        .then(function(data) {
          console.log('neworder succeeded with JSON response', data);  
          callback(data);
          })
        .catch(function(error) {  
          console.log('neworder failed', error);
          callback(false);
        })
    }
 
    deleteOrder (id, callback){
      const data = { session: store.auth.session, id: id };

      this.request('GET', 'delete?' + queryparams(data))
        .then(status)  
        .then(json)  
        .then(function(data) {
          console.log('delete succeeded with JSON response', data);  
          callback(data);
          })
        .catch(function(error) {  
          console.log('getdata failed', error);
          callback(false);
        })
    }

    getData (callback){
      const data = { session: store.auth.session };

      this.request('GET', 'getdata?' + queryparams(data))
        .then(status)  
        .then(json)  
        .then(function(data) {
          console.log('getdata succeeded with JSON response', data);  
          callback(data);
          })
        .catch(function(error) {  
          console.log('getdata failed', error);
          callback(false);
        })
    }

    getHotels (callback){
      const data = { session: store.auth.session };

      this.request('GET', 'hotels?' + queryparams(data))
        .then(status)  
        .then(json)  
        .then(function(data) {
          console.log('gethotels succeeded with JSON response', data);    
          callback(data);
          })
        .catch(function(error) {  
          console.log('hotels failed', error);
          callback(false);
        })
    }

    getLinks (callback){
      const data = { session: store.auth.session };

      this.request('GET', 'links?' + queryparams(data))
        .then(status)  
        .then(json)  
        .then(function(data) {
          console.log('getlinks succeeded with JSON response', data);     
          callback(data);
          })
        .catch(function(error) {  
          console.log('links failed', error);
          callback(false);
        })
    }

    newMethod() {
      let session = store.auth.session;      
      const requestBody = { session: session };
      this.request('POST', 'newMethod', JSON.stringify(requestBody) )
        .then(status)  
        .then(json)  
        .then(function(data) {  
          console.log('newmethod succeeded with JSON response', data);
          if (data.type === 'ok'){
            //обработка

          }
          else alert(data.message);
        })
        .catch(function(error) {  
          console.log('Logout failed', error);  
        });
    }

}

var api = new Api();
export default api;


// WEBPACK FOOTER //
// ./src/api/server_api.js